<template>
  <div class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> Sales Agent {{ salesAgent_id ? " - Edit" : " - New"}}</div>
        <b-button-group>
          <router-link :to="`/settings/salesAgents`" class="link">        
            <b-button class="custom-cancel"><i class="fa fa-times text-danger"></i>
               Cancel
            </b-button>
          </router-link>
          <b-button v-on:click="post('andClose')" :disabled="disabled || submitted"><i class="fa fa-save"></i> Save & Close</b-button>
          <b-button v-on:click="post()" :disabled="disabled"><i class="fa fa-check text-success "></i> Apply</b-button> 
          <b-button variant="" id="custom-button" @click="modalMergeOpen = true" v-b-popover.hover.top="'Merge'" >
            <i class="fa fa-star-half-full"></i> Merge
          </b-button> 
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="4">
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
              
              <b-form-group id="buttonGroup">
                <b-button v-on:click="selectForm('basicInfo')" block :variant=" selectedForm == 'basicInfo' ? 'primary' : 'outline-primary' " class="btn-square">Basic info</b-button>
                <b-button v-on:click="selectForm('optionalInfo')" block :variant=" selectedForm == 'optionalInfo' ? 'primary' : 'outline-primary' " class="btn-square">Optional info</b-button>
                <b-button v-on:click="selectForm('pointsInfo')" block :variant=" selectedForm == 'pointsInfo' ? 'primary' : 'outline-primary' " class="btn-square">Points info
                  <i v-if="errors.count() > 0" 
                          class="fa fa-exclamation color-red"
                          v-b-popover.hover.top="'Fill the required fields!'">
                  </i>
                </b-button>
              </b-form-group>
              
              <!-- score -->
              <b-form-group id="scoreInputGroup1" label="Score" label-for="score">
                <b-form-input id="score"
                  type="number"
                  v-model.lazy.trim="$v.form.score.$model"
                  :state="chkState('score')"
                  aria-describedby="input1LiveFeedback1"
                  placeholder="Score"                    
                  />
                <b-form-invalid-feedback id="input1LiveFeedback1">
                  This is a required field and must be at least 1 characters
                </b-form-invalid-feedback>
              </b-form-group>
                
              <hr class="mnr-md mnl-md">

              <!-- select from Sales Agent -->
              <label class="d-block">Sales Manager</label> 
              <b-form-select id="salesManager" label="Sales Agent owner" class="form-group"
                :plain="true"
                :options="this.salesManagerOptions"
                v-model.lazy.trim="$v.form.salesManager.$model"
                value="Please select an owner">
              </b-form-select>     
              
              <label class="d-block">Platform type</label>
              <b-form-select id="platformType" label="Platform Type" class="form-group"
                :plain="true"
                v-on:change="this.getPlatformType"
                :options="this.platformTypeOptions"
                v-model.lazy.trim="$v.form.platformType.$model"
                value="Please select an owner">
              </b-form-select>   
              <b-row v-if="platformTypeSelected === 'white-label'">
                <b-col md="12">
                  <b-row>
                    <b-col md="5">
                      <b-form-group label="Sub Domain" label-for="subDomainName">
                        <b-form-input
                          id="subDomainName"
                          type="text"
                          :state="chkState('subDomainName')"
                          v-model.lazy.trim="$v.form['subDomainName'].$model"
                          placeholder="Sub Domain"
                        />
                        <b-form-invalid-feedback>Invalid Sub Domain that is a required field and must be at least 2 characters</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col md="7">
                      <b-form-group label="Domain" label-for="fullDomainName">
                        <b-form-input
                          id="fullDomainName"
                          type="text"
                          :state="chkState('fullDomainName')"
                          :disabled="platformTypeSelected === 'white-label'"
                          v-model.lazy.trim="$v.form['fullDomainName'].$model"
                          placeholder="Domain Name"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="platformTypeSelected === 'full white-label'">
                <b-col md="12">
                  <b-form-group label="Full Domain Configuration" label-for="fullDomainName">
                    <b-form-input
                      id="fullDomainName"
                      type="text"
                      :state="chkState('fullDomainName')"
                      v-model.lazy.trim="$v.form['fullDomainName'].$model"
                      placeholder="Domain Name"
                    />
                    <b-form-invalid-feedback>Invalid Domain Name</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>    
              <b-row v-if="platformTypeSelected === 'full white-label'">
                <b-col md="12">
                  <b-alert variant="success" show>
                    Please use and map following CNAME <br /> `<b>d19c26c2ofwtkt.cloudfront.net</b>` <br /> in your Domain Name Servers(DNS).
                  </b-alert>
                </b-col>
              </b-row>       
            </b-form>
          </b-col>

          <b-col md="7" >
            <div v-if="selectedForm === 'basicInfo'" style="border: 1px solid #c8ced3;">
              <b-card-header class="custom-header">
                <div style="font-weight: 600;"><i class="icon-home mr-1"></i>Basic info</div>               
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col md="6">
                    <!-- Sales Agent Name -->
                    <b-form-group label="Sales Agent Name" label-for="salesAgentName">
                      <b-form-input id="salesAgentName"
                        type="text"
                        v-model.lazy.trim="$v.form['salesAgentName'].$model"
                        :state="chkState('salesAgentName')"    
                        placeholder="salesAgentName"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col>                  
                  <b-col md="6">
                    <!-- Email --> 
                    <b-form-group id="emailInputGroup4" label="Email" label-for="email">
                      <b-form-input id="email"
                        type="email"
                        v-model.trim="$v.form.email.$model"
                        :state="chkState('email')"
                        aria-describedby="input1LiveFeedback4"
                        placeholder="Email"
                        autocomplete='email' />
                      <b-form-invalid-feedback id="input1LiveFeedback4">
                        This is a required field and must be valid e-mail address
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr class="mnr-md mnl-md">
                
                <b-row>
                  <b-col md="12">
                    <!-- Sales Agent Address -->
                    <label>Sales Agent Address</label>
                    <b-form-group>
                      <b-form-input id="address1"
                        type="text"
                        v-model.lazy.trim="$v.form.address1.$model"
                        :state="chkState('address1')"    
                        placeholder="Address 1"
                          />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 5 characters
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input id="address2"
                        type="text"
                        v-model.lazy.trim="$v.form.address2.$model"
                        :state="chkState('address2')"    
                        placeholder="Address 2"
                          />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 5 characters
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-row>
                      <b-col md="6">
                        <b-form-group label="Country" label-for="country">
                          <b-form-select id="country" label="Country" class="form-group"
                            :plain="true"
                            :options="this.countryListOptions"
                            v-model.lazy.trim="$v.form.country.$model"
                            :state="chkState('country')"  
                            value="Please select a country">
                          </b-form-select>   
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <!-- stateName -->
                        <b-form-group label="stateName" label-for="stateName">
                          <b-form-input id="stateName"
                            type="text"
                            v-model.lazy.trim="$v.form.stateName.$model"
                            :state="chkState('stateName')"    
                            placeholder="State"
                              />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="6">                      
                        <b-form-group label="Zip Code" label-for="zipcode">
                          <b-form-input id="zipcode"
                            type="text"
                            v-model.lazy.trim="$v.form.zipcode.$model"
                            :state="chkState('zipcode')"    
                            placeholder="Zip Code"
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <!-- City -->
                        <b-form-group label="City" label-for="city">
                          <b-form-input id="city"
                            type="text"
                            v-model.lazy.trim="$v.form.city.$model"
                            :state="chkState('city')"    
                            placeholder="City"
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-form-group label="Phone" label-for="phone">
                      <b-form-input id="phone"
                        type="text"
                        v-model.lazy.trim="$v.form.phone.$model"
                        :state="chkState('phone')"    
                        placeholder="Phone"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group>
                    
                    <b-form-group label="Web Site" label-for="website">
                      <b-form-input id="website"
                        type="text"
                        v-model.lazy.trim="$v.form.website.$model"
                        :state="chkState('website')"    
                        placeholder="Website"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 7 characters
                      </b-form-invalid-feedback>
                    </b-form-group>

                  </b-col>
                </b-row>
              </b-card-body>

            </div>
            <div v-show="selectedForm === 'optionalInfo'" style="border: 1px solid #c8ced3;">
              <b-card-header class="custom-header">
                <div style="font-weight: 600;"><i class="icon-layers mr-1"></i>Optional info</div>               
              </b-card-header>
              <b-card-body>
                <b-row> 
                  <b-col md="12">                
                    <!-- Number Of Employees -->
                    <label>Number Of Employees</label>
                    <b-form-group>
                      <b-form-input id="numberOfEmployees"
                        type="number"
                        v-model.lazy.trim="$v.form.numberOfEmployees.$model"
                        :state="chkState('numberOfEmployees')"    
                        placeholder="Number Of Employees"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 1 characters
                      </b-form-invalid-feedback>
                    </b-form-group>                 
                  </b-col>
                </b-row>    
                <b-row> 
                  <b-col md="12">                
                    <!-- Number Of Employees -->
                    <label>Fax</label>
                    <b-form-group>
                      <b-form-input id="fax"
                        type="text"
                        v-model.lazy.trim="$v.form.fax.$model"
                        :state="chkState('fax')"    
                        placeholder="Fax"
                          />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 1 characters
                      </b-form-invalid-feedback>
                    </b-form-group>                 
                  </b-col>
                </b-row>  
                <b-row> 
                  <b-col md="12">                
                    <!-- annualRevenue -->
                    <label>Annual Revenue</label>
                    <b-form-group>
                      <b-form-input id="annualRevenue"
                        type="text"
                        v-model.lazy.trim="$v.form.annualRevenue.$model"
                        :state="chkState('annualRevenue')"    
                        placeholder="Annual Revenue"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 1 characters
                      </b-form-invalid-feedback>
                    </b-form-group>                 
                  </b-col>
                </b-row>

                <b-row> 
                  <b-col md="12">  
                    <b-form-group label="Industry" label-for="industry">
                      <b-form-select id="industry" label="Industry" class="form-group"
                        :plain="true"
                        :options="['aaaa', 'bbbb', 'ccccc', 'dddd']"
                        v-model.lazy.trim="$v.form.industry.$model"
                        :state="chkState('industry')"  
                        value="Please select a industry">
                      </b-form-select>   
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row> 
                  <b-col md="12">  
                   <!-- Description -->
                    <label>Description</label>
                    <b-form-group>
                      <b-form-input id="description"
                        type="text"
                        v-model.lazy.trim="$v.form.description.$model"
                        :state="chkState('description')"    
                        placeholder="Description"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group>  
                  </b-col>
                </b-row>

              </b-card-body> 
            </div>
            <div v-show="selectedForm === 'pointsInfo'" style="border: 1px solid #c8ced3;">
              <b-card-header class="custom-header">
                <div style="font-weight: 600;"><i class="fa fa-star-o mr-1"></i>Points info</div>               
              </b-card-header>
              <b-card-body>
                <b-row> 
                  <b-col md="12">
                    <!-- Choose Main Technology -->
                    <b-form-group
                      label="Main Technologies"
                      label-for="description"
                      label-class="font-weight-bold pt-0"
                    >
                    <div 
                      class="custom-control custom-checkbox custom-control-inline margin-bottom-5"
                      v-for="mainTech in mainTechs" :key="mainTech.id"
                    >
                      <input type="checkbox" 
                        class="custom-control-input" 
                        :id="`${mainTech.id}_chk_${mainTech.techProductName}`"
                        :name="`${mainTech.id}_chk_${mainTech.techProductName}`"
                        @change="selectTech(mainTech.id)"
                        :checked="savedTechProductsIdFromDB.indexOf(mainTech.id) > -1"
                        >
                      <label class="custom-control-label padding-top-1" 
                        :for="`${mainTech.id}_chk_${mainTech.techProductName}`"
                        :id="`${mainTech.id}_label_${mainTech.techProductName}`"
                      >
                        <i v-if="mainTech.icon_class!='NULL'"
                          :class="mainTech.icon_class"
                        ></i>
                        <img v-if="mainTech.icon_image!='NULL'"
                          :src="mainTech.icon_image"
                          class="tech-image"
                        />
                        {{mainTech.title}}
                      </label>
                      <b-popover :target="`${mainTech.id}_label_${mainTech.techProductName}`" placement="top" triggers="hover focus" v-if="mainTech.full_title!='NULL'">
                        {{mainTech.full_title}}
                      </b-popover>
                    </div>
                    </b-form-group>
                    <!-- Choose Sub Technology -->
                    <b-form-group
                      label="Sub Technologies"
                      label-for="description"
                      label-class="font-weight-bold pt-0"
                    >
                    <div 
                      class="custom-control custom-checkbox custom-control-inline margin-bottom-5"
                      v-for="subTech in subTechs" :key="subTech.id"
                    >
                      <input type="checkbox" 
                        class="custom-control-input" 
                        :id="`${subTech.id}_chk_${subTech.techProductName}`"
                        :name="`${subTech.id}_chk_${subTech.techProductName}`"
                        @change="selectTech(subTech.id)"
                        :checked="savedTechProductsIdFromDB.indexOf(subTech.id) > -1"
                        >
                      <label class="custom-control-label" 
                        :for="`${subTech.id}_chk_${subTech.techProductName}`"
                        :id="`${subTech.id}_label_${subTech.techProductName}`"
                        
                      >
                        <i v-if="subTech.icon_class!='NULL'"
                          :class="subTech.icon_class"
                        ></i>
                        <img v-if="subTech.icon_image!='NULL'"
                          :src="subTech.icon_image"
                          class="tech-image"
                        />
                        {{subTech.title}}
                      </label>
                      <b-popover :target="`${subTech.id}_label_${subTech.techProductName}`" placement="topright" triggers="hover focus" v-if="subTech.full_title!='NULL'">
                        {{subTech.full_title}}
                      </b-popover>
                    </div>
                    </b-form-group>
                    <!-- Choose Platform Technology -->
                    <b-form-group
                      label="Platform Technologies"
                      label-for="description"
                      label-class="font-weight-bold pt-0"
                    >
                    <div 
                      class="custom-control custom-checkbox custom-control-inline margin-bottom-5"
                      v-for="platformTech in platformTechs" :key="platformTech.id"
                    >
                      <input type="checkbox" 
                        class="custom-control-input" 
                        :id="`${platformTech.id}_chk_${platformTech.techProductName}`"
                        :name="`${platformTech.id}_chk_${platformTech.techProductName}`"
                        @change="selectTech(platformTech.id)"
                        :checked="savedTechProductsIdFromDB.indexOf(platformTech.id) > -1"
                        >
                      <label class="custom-control-label" 
                        :for="`${platformTech.id}_chk_${platformTech.techProductName}`"
                        :id="`${platformTech.id}_label_${platformTech.techProductName}`"
                        
                      >
                        <i v-if="platformTech.icon_class!='NULL'"
                          :class="platformTech.icon_class"
                        ></i>
                        <img v-if="platformTech.icon_image!='NULL'"
                          :src="platformTech.icon_image"
                          class="tech-image"
                        />
                        {{platformTech.title}}
                      </label>
                      <b-popover :target="`${platformTech.id}_label_${platformTech.techProductName}`" placement="topright" triggers="hover focus" v-if="platformTech.full_title!='NULL'">
                        {{platformTech.full_title}}
                      </b-popover>
                    </div>
                    </b-form-group> 

                      <b-form-group
                        label="Points For selected Tech(s)"
                        label-for="description"
                        label-class="font-weight-bold pt-3 color-20a8d8 underline"
                        
                        v-if="tech_products_points.length > 0"
                      >
                        
                        <b-list-group>
                          <b-list-group-item v-for="selected_tech_product in tech_products_points" :key="selected_tech_product.tech_product_id">
                            <b-row>
                              <b-col md="5">
                                <label class="font-size-13">
                                {{ selected_tech_product.tech_product_title }}
                                </label>
                              </b-col>
                              <b-col md="7">
                                <!-- Segment Count -->
                                <b-form-group
                                  label="Points:"
                                  label-for="txtTechPoints"
                                  label-class="font-weight-bold pt-0 required font-size-13"
                                  label-cols-sm="3"
                                  label-cols-lg="3"
                                >
                                  <b-input-group>
                                    <b-input-group-prepend>
                                      <b-input-group-text><i class="fa fa-star"></i></b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input :id="`selected_tech_product_${selected_tech_product.tech_product_id}_point`"
                                      type="number"
                                      v-model.lazy.trim="selected_tech_product.tech_product_point"
                                      v-validate="'required'"
                                      :class="{'form-control is-invalid': errors.first(`selected_tech_product_${selected_tech_product.tech_product_id}_point`)}"
                                      :name="`selected_tech_product_${selected_tech_product.tech_product_id}_point`"
                                      placeholder=""
                                      
                                    />
                                  </b-input-group>
                                  <b-form-invalid-feedback id="setCountLiveFeedback" v-if="errors.has(`selected_tech_product_${selected_tech_product.tech_product_id}_point`)" style="display:block;">
                                    Point is required.
                                  </b-form-invalid-feedback> 
                                </b-form-group>
                              </b-col>                             
                            </b-row>
                          </b-list-group-item>                                        
                        </b-list-group>
                      </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body> 
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Modal Merge -->
    <div class="custom-modal" v-if="modalMergeOpen" @ok="doSomething()">
      <div role="dialog" tabindex="-1" class="modal fade show" aria-modal="true" style="display: block;">
        <div class="modal-dialog modal-md">
          <div role="document" aria-labelledby="modal_header" class="modal-content">
            <header id="modal_header" class="modal-header">
              <h5 class="modal-title">Merging current sales agent</h5>
              <button type="button" aria-label="Close" @click="modalMergeOpen = false" class="close">×</button>
            </header>
            <div class="modal-body">
              <b-form-group label="Choose a sales agent to merge into" label-for="industry">
                <b-form-select id="industry" class="form-group"
                  :plain="true"
                  :options="['aaaa', 'bbbb', 'ccccc', 'ddddd']"
                  v-model.lazy.trim="$v.form.industry.$model"
                  :state="chkState('industry')" 
                  value="">
                </b-form-select>   
                <b-form-invalid-feedback>
                  This is a required field and must be at least 2 characters
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <footer id="modal_footer" class="modal-footer">             
              <b-button @click="modalMergeOpen = false" class="custom-close-btn"><i class="fa fa-times text-danger"></i>      
                <span class="link">&nbsp;Cancel</span>    
              </b-button>            
              <b-button class="custom-close-btn" @click="doSomething()" :disabled="$v.form.$invalid || submitted">
                <i class="fa fa-check text-success"></i>&nbsp;Merge
              </b-button>      
            </footer>
          </div>
        </div>
      </div>
      <div tabindex="0"></div>
      <div id="modal_backdrop" class="modal-backdrop"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers, url, alpha } from "vuelidate/lib/validators";
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import { mapState, mapActions } from 'vuex';
import { apigClient } from '@/shared/api';
import { cipher } from '@/shared/cipher';
import { userPool } from '@/shared/cognito';
import { timezones } from '@/shared/helper';
import { countryList } from '@/shared/helper';
import Modals from "@/shared/Modals.vue";

const Spinner = () => import('../shared/Spinner');
const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options);
var tzList = timezones.tz.names().map((elem, index)=>{
  return {name:elem, id:index};
});
const formShape = {
  score: 0,
  salesManager: "",
  salesAgentName: "",
  platformType: "",
  subDomainName: "",
  fullDomainName: "",
  email: "",
  address1: "",
  address2: "",
  city: "",
  stateName: "",
  zipcode: "",
  country: "",
  phone: "",
  website: "",
  numberOfEmployees: 1,
  fax:"",
  annualRevenue:"", 
  industry:"",
  description:"",
}
let validations = {
  form: {
    score: {
      required,
      minLength: minLength(1)
    },
    salesManager: {
      required: false,
    },
    platformType: {
      required: false,
    },
    subDomainName: {
      alpha,
      minLength: minLength(3)
    },
    fullDomainName: {
      alpha: helpers.regex('alpha', /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/)
    },
    salesAgentName: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    address1: {
      required,
      minLength: minLength(5)
    },
    address2: {},
    city:{},
    stateName:{},
    zipcode:{},
    country:{},
    phone:{},
    website:{
      url
    },
    numberOfEmployees: {},
    fax: {},
    annualRevenue: {},
    industry: {},
    description: {},
  }
}
export default {
  name: "SalesAgent",
  components: {
    cSwitch,
    Spinner,
    Modals
  },
  data() {
    if(window.location.href.includes("/settings/salesAgent/edit")){
      var salesAgent_id = localStorage.getItem('page_salesAgent_id');
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      title:'',
      form: Object.assign({}, formShape),
      feedBack: 'secondary',
      submitted: false,
      disabled: true,
      isLoading: true,
      selectedForm: 'basicInfo',
      modalMergeOpen: false,
      salesAgent_id: salesAgent_id || null,
      showFeedBackRole: false,
      salesManagerOptions: [],
      salesManagerIds: [],
      countryListOptions: countryList,
      allTechs: [], 
      mainTechs: [],
      subTechs: [],
      platformTechs: [],
      tech_products_points: [],
      savedTechProductsIdFromDB: [],
      platformTypeSelected: 'demo',
      fullDomainNameTmp: '.cn2.ypb.io',
      platformTypeOptions: [
        'demo',
        'branded',
        'white-label',
        'full white-label'
      ],
      nonPlatformOptions: [
        'demo',
        'branded'
      ],
      oldSubDomainName: null,
      oldFullDomainName: null,
    }
  },
  
  created: function() {
    
  },
  
  mounted: function(){
    var that = this;
    this.getUsersData();
    that.form.platformType = this.platformTypeSelected;
    that.form.fullDomainName = this.platformTypeSelected === 'full white-label' ? 'https://' : this.fullDomainNameTmp;
    if ( this.salesAgent_id ){
      this.getSalesAgentData();
      this.title = 'SalesAgent - Edit ( id:' + this.salesAgent_id + ')';
    } else {
      this.title = 'Sales Agent - New';
      this.getTechProductsData();
      this.isLoading = false;
    }
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPlatformType: function(platformType) {
      this.platformTypeSelected = platformType;
      this.form.fullDomainName = platformType === 'white-label' ? this.fullDomainNameTmp : '';
      if (platformType === 'white-label') {
        this.chkState('fullDomainName');
      }
      this.form.fullDomainName = platformType === 'full white-label' && (this.form.fullDomainName === 'NULL' && (this.form.fullDomainName.length === 0)) ? '' : this.form.fullDomainName;
    },
    selectForm:function(selectedForm){
      this.selectedForm = selectedForm;
    },
    selectTech(id){
      var that = this;
      if(id){
        // Search the clicked tech is already in the points defining list or not
        let exiting_tech_product_point = that.tech_products_points.findIndex(s => s.tech_product_id === id);
        
        if(exiting_tech_product_point >= 0){
          // if already exists, remove from that points
          that.tech_products_points.splice(exiting_tech_product_point, 1);
        } else {
          // if not exists, add as a new one
          // get the whole tech information by id first, to addd title in the points list
          let seletect_tech_product = that.allTechs.find(tech_product => {return tech_product.id == id});
          if(seletect_tech_product.title){
            var tech_product_point = {};
            tech_product_point['tech_product_id'] = id;
            tech_product_point['tech_product_title'] = seletect_tech_product.title;
            tech_product_point['tech_product_point'] = 0;
            that.tech_products_points.push(tech_product_point);
          }
        }
        
      }
    },
    post:function(option){
      var that = this; 
      // checking error counts from points defining
      if(that.errors.count() > 0){
        return;
      }
      this.isLoading = true;
      var body = {
        salesAgentName: that.form.salesAgentName,
        salesManager: that.form.salesManager,    
        platformType: that.form.platformType, 
        subDomainName: that.form.platformType === 'white-label' ? that.form.subDomainName : '',
        fullDomainName: that.nonPlatformOptions.indexOf(that.form.platformType) > -1 ? '' : that.form.fullDomainName,
        oldSubDomainName: that.oldSubDomainName,
        oldFullDomainName: that.oldFullDomainName,
        score: that.form.score,                      
        email: that.form.email,          
        address1: that.form.address1,          
        address2: that.form.address2,          
        country: that.form.country,          
        stateName: that.form.stateName,          
        zipcode: that.form.zipcode,          
        city: that.form.city,          
        phone: that.form.phone,          
        website: that.form.website,                 
        numberOfEmployees: that.form.numberOfEmployees,
        fax: that.form.fax,
        annualRevenue: that.form.annualRevenue,
        industry: that.form.industry,
        techProductsPoints: that.tech_products_points,
        description: that.form.description,
        createdBy: that.loginUserInfo.login_username, 
        updateBy: that.loginUserInfo.login_username
      };
      if(false) {
      } else {
        if(this.salesAgent_id){
        this.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating Sales Agent Info"
        );
          var method = 'PUT';
          var pathTemplate = '/salesAgents/' + this.salesAgent_id;
          var additionalParams ={};
          var pathParams = {};
          apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function(result){
              if (result.data.status) {
                // that.showSuccessMsgUpdate();
                if ( option == "andClose" ){
                that.changeModalContent(
                  "success",
                  "Updated success!",
                  "The Sales Agent data has been updated"
                );                  
                  setTimeout(() => {
                  router.push(`/settings/salesAgents`);
                  }, 2000) 
              } else {
                // that.showErrorMsg({message: result.data.message});
                setTimeout(() =>{
                  that.changeModalContent(
                    "success",
                    "Updated success!",
                    "The Sales Agent data has been updated"
                  );  
                  setTimeout(() => {
                    that.$refs.form.closeModal();
                  }, 2000);
                }, 2000);
              }
            } else {
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }


            }).catch( function(result){
              // that.showErrorMsg({message: result.message});
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result
              );
            });
        } else {
          this.$refs.form.openModal();
          var method = 'POST';
          var pathTemplate = '/salesAgents';
          var additionalParams ={
          };
          var pathParams = {
          };
          apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function(result){
              console.log(result);
              if (result.data.status) {
                // that.showSuccessMsgCreate();
                if (option == "andClose") {
                  that.changeModalContent(
                    "success",
                    "Saved success!",
                    "The Sales Agent data has been created"
                  );
                  localStorage.setItem('page_salesAgent_id', result["data"]["data"]);
                  setTimeout(() => {
                    router.push(`/settings/salesAgents`);
                  }, 2000)
              } else {
                // Apply
                that.changeModalContent(
                  "success",
                  "Saved success!",
                  "The Sales Agent data has been created"
                );
                setTimeout(() => {
                  that.$refs.form.closeModal();
                }, 2000);
              }
              } else {
                // that.showErrorMsg({message: result.data.message});
                that.changeModalContent(
                  "error",
                  "Error Occured!",
                  "Error From API Endpoint: " + result.data.message
                );
              }         
            }).catch( function(result){
              // that.showErrorMsg({message: result.message});
              that.changeModalContent(
                "error",
                "Error Occured!",
                "invokeAPI Error: " + result.message
              );
            });
          }
        }
      this.isLoading = false;
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    routerBack(){
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.validate() ) {
        this.$nextTick(() => {
          // submit
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    chkState(val) {
      const field = this.$v.form[val];
      let salesAgentName = this.$v.form["salesAgentName"];
      let salesManager = this.$v.form["salesManager"];
      let address1 = this.$v.form["address1"];
      let country = this.$v.form["country"];
      let zipcode = this.$v.form["zipcode"];
      let city = this.$v.form["city"];
      let platformType = this.$v.form["platformType"];
      let subDomainName = this.$v.form["subDomainName"];
      let fullDomainName = this.$v.form["fullDomainName"];
      let basicFieldsInvalid =
        (platformType.$model === 'full white-label' && (fullDomainName.$model !== undefined && fullDomainName.$model !== '') && !fullDomainName.$invalid) ||
        (platformType.$model === 'white-label' && (subDomainName.$model !== undefined && subDomainName.$model !== '') && !subDomainName.$invalid) || 
        (this.nonPlatformOptions.indexOf(platformType.$model) > -1 && !salesAgentName.$invalid && !address1.$invalid && !platformType.$invalid);
      this.disabled = !basicFieldsInvalid;
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid;
    },
    getTechProductsData(savedTechProductsPoints = []){
      var that = this;
      var method = 'GET';
      var pathTemplate = '/tech-products';
      var additionalParams ={};
      var pathParams = {};
      var userDatas = [];
      var that = this;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(results){
        var data = results["data"]["data"];
        that.allTechs = data;
        that.mainTechs = data.filter(item => {return item.type === 'main'});
        that.subTechs = data.filter(item => {return item.type === 'sub'});
        that.platformTechs = data.filter(item => {return item.type === 'platform'});
        // In Sales Agent Edit Mode, will render savedTechProductPoints List
        if(savedTechProductsPoints){
          savedTechProductsPoints.forEach((savedTechProductPoint) => {
            // get the whole tech information by id first, to addd title in the points list
            let tech_product_info = that.allTechs.find(tech_product => {return tech_product.id == savedTechProductPoint.tech_product_id});
            if(tech_product_info.title){
              var tech_product_point = {};
              tech_product_point['tech_product_id'] = savedTechProductPoint.tech_product_id;
              tech_product_point['tech_product_title'] = tech_product_info.title;
              tech_product_point['tech_product_point'] = savedTechProductPoint.tech_product_point;
              that.tech_products_points.push(tech_product_point);
              // save id to id list to auto select the tech checkboxes.
              that.savedTechProductsIdFromDB.push(savedTechProductPoint.tech_product_id);
            }
          });
        }
        that.isLoading = false;
      }).catch( function(error){
        that.showErrorMsg({message: error.message});
      });
    },
    getUsersData : function() {
        var method = 'GET';
        var pathTemplate = '/users';
        var additionalParams ={};
        var pathParams = {};
        var userDatas = [];
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results){
          var datas = results["data"]["data"];
          for(var i = 0; i < datas.length; i++) {
            if(datas[i]["group_id"] == 2){
              that.salesManagerOptions.push(datas[i]["firstname"]+" "+datas[i]["lastname"]);
              that.salesManagerIds.push(datas[i])["id"];
            }
          }     
          that.isLoading = false;
        }).catch( function(error){
          that.showErrorMsg({message: error.message});
        });
    }, 
    getSalesAgentData: function() {
      let method = 'GET';
      let pathTemplate = '/salesAgents/'+this.salesAgent_id;
      let additionalParams ={};
      let pathParams = {};
      let salesAgentData = [];
      let that = this;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          if (result.data.status) {
            var salesAgentData = result["data"]["data"];
            that.form.salesAgentName = salesAgentData.salesAgentName;
            that.form.salesManager = salesAgentData.salesManager;
            that.form.platformType = salesAgentData.platformType;
            that.platformTypeSelected = salesAgentData.platformType;
            that.form.subDomainName = salesAgentData.subDomainName === 'NULL' ? '' : salesAgentData.subDomainName;
            that.form.fullDomainName = salesAgentData.fullDomainName === 'NULL' ? '' : salesAgentData.fullDomainName;
            that.oldSubDomainName = that.form.subDomainName;
            that.oldFullDomainName = that.form.fullDomainName;
            that.form.score = salesAgentData.score === 'NULL' || salesAgentData.score === undefined ? 0 : salesAgentData.score;
            that.form.email = salesAgentData.email;
            that.form.address1 = salesAgentData.address1;
            that.form.address2 = salesAgentData.address2;
            that.form.country = salesAgentData.country;
            that.form.stateName = salesAgentData.stateName;
            that.form.zipcode = salesAgentData.zipcode;
            that.form.city = salesAgentData.city;
            that.form.phone = salesAgentData.phone;
            that.form.website = salesAgentData.website;
            that.form.user_id = salesAgentData.user_id;
            that.form.numberOfEmployees = salesAgentData.numberOfEmployees;
            that.form.fax = salesAgentData.fax;
            that.form.annualRevenue = salesAgentData.annualRevenue;
            that.form.industry = salesAgentData.industry;
            that.form.description = salesAgentData.description;
            that.form.updateBy = salesAgentData.updateBy
            //This is where you would put a success callback
            that.isLoading = false;
            that.getTechProductsData(salesAgentData.techProductsPoints === 'NULL' ? [] : salesAgentData.techProductsPoints);
          } else {
            that.showErrorMsg({message: result.data.message});
            that.isLoading = false;
          }
      }).catch( function(error){
        that.showErrorMsg({message: error.message});
        that.isLoading = false;
        //This is where you would put an error callback
      });
    },
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Sales Agent data has been create'
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Sales Agent data has been update'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ''
    }
  },
}
</script>



<style scoped>
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }
  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }
    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 
  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }
  label {
    font-weight: 600!important;
  }
</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }
  .tech-image{
    height:15px;
  }
  .form-group label.required:after {
    content: " *";
    color: #f86b4f;
  }
  .color-20a8d8{
    color:#20a8d8;
  }
  .underline{
    text-decoration: underline;
  }
  .font-size-13{
    font-size:13px !important;
  }
  .color-red{
    color:red;
  }
  .margin-bottom-5{
    margin-bottom: 5px;
  }
</style>